<div id="mail-list-chooser">
  // TODO : mail list chooser
</div>

<div class="mt-1 mb-1">
  <button type="button" (click)="togglePreview()" class="btn btn-secondary">
    <ng-container *ngIf="preview; else notPreview">
      <i class="fa fa-pencil"></i> Módosítás
    </ng-container>
    <ng-template #notPreview>
      <i class="fa fa-eye"></i> Előnézet
    </ng-template>
  </button>
  <button type="button" class="btn btn-primary" (click)="send()"><i class="fa fa-paper-plane-o"></i> Küldés</button>
</div>

<div *ngIf="preview">
  <kkk-email-preview [htmlText]="html"></kkk-email-preview>
</div>

<div *ngIf="!preview">
  <quill-editor [(ngModel)]="html" [placeholder]="'Ide írd az üzenet tartalmát'">
    <div quill-editor-toolbar>
      <div class="ql-formats">

        <!-- Add font size dropdown -->
        <select class="ql-header">
          <option value="1">Címsor 1</option>
          <option value="2">Címsor 2</option>
          <option value="3">Címsor 3</option>
          <option value="4">Címsor 4</option>
          <option value="5">Címsor 5</option>
          <option value="6">Címsor 6</option>
          <option selected>Normál</option>
        </select>

        <!-- Add font size dropdown -->
        <select class="ql-size">
          <option value="small">Kicsi</option>
          <!-- Note a missing, thus falsy value, is used to reset to default -->
          <option selected>Normál</option>
          <option value="large">Nagy</option>
          <option value="huge">Óriási</option>
        </select>

      </div>

      <div class="ql-formats">
        <button class="ql-bold" placement="bottom" ngbTooltip="Félkövér"></button>
        <button class="ql-italic" placement="bottom" ngbTooltip="Dőlt"></button>
        <button class="ql-underline" placement="bottom" ngbTooltip="Aláhúzott"></button>
        <button class="ql-strike" placement="bottom" ngbTooltip="Áthúzott"></button>
      </div>

      <div class="ql-formats">
        <select class="ql-align">
          <option selected></option>
          <option value="center"></option>
          <option value="right"></option>
          <option value="justify"></option>
        </select>
      </div>

      <div class="ql-formats">
        <button type="button" class="ql-list" value="bullet" placement="bottom" ngbTooltip="Felsorolás"></button>
        <button type="button" class="ql-list" value="ordered" placement="bottom" ngbTooltip="Számozott lista"></button>
      </div>

      <div class="ql-formats">
        <button class="ql-blockquote" placement="bottom" ngbTooltip="Idézet"></button>
      </div>

      <div class="ql-formats">
        <button class="ql-link" placement="bottom" ngbTooltip="Link"></button>
        <button class="ql-image" placement="bottom" ngbTooltip="Kép beszúrása"></button>
      </div>
    </div>
  </quill-editor>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-composer/email-composer.component.html